module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAlElEQVQ4y2NgGBSgQ8b3v6BG+38GrX7SMAycF9H+v0/M+L+Tcj75BsDw/cTC/7/fvPtPDMBqAAhfVrf5/2HLHtINeJhVgWJQt7QP/rBBNuBxaRPYVBCNbMhaCev/UQrJhA24ZuH9/25Y+v9rpp5wzb3S3sS7AD0M3q/fTl4g3ovPIy8WQOnAXSmXvHRA0K+EDBjaAABc43Nf+ckMwQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CU.png
// module id = 1116
// module chunks = 0